import { React } from "react";
const Estadisticas = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe title="Estadisticas" className=" w-full h-full border-0"
        src="https://lookerstudio.google.com/embed/reporting/7391db08-0b47-4036-8204-1adadb751717/page/GHRBE"
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe></div>
    )
}
export default Estadisticas;